import SAAlert from './Alert'

export default SAAlert
